import { useEffect, useRef } from "react";
import { DomEvent } from "leaflet";
import classes from "./NodeBox.module.scss";
import CloseButton from "../buttons/CloseButton";

const GridCellBox = ({ gridCell, onClose, userRole }) => {
    const containerRef = useRef(null);

    useEffect(() => {
        if (containerRef.current) {
            DomEvent.disableScrollPropagation(containerRef.current);
        }
    }, []);

    if (!gridCell) return null;

    return (
        <div className={classes.nodeBox} ref={containerRef}>
            <CloseButton onClose={onClose} />

            <ul>
                <li>
                    <span>
                        <b>Grid Cell:</b>
                    </span>
                    <span className={classes.prop}>X: {gridCell.x}</span>
                    <span className={classes.prop}>Y: {gridCell.y}</span>
                </li>

                {userRole === "admin" && (
                    <li>
                        <div className={classes.btn}>Make sea route</div>
                    </li>
                )}

                <li>
                    <div className={classes.btn}>Add new ship here</div>
                </li>
            </ul>
        </div>
    );
};

export default GridCellBox;